<app-nav-header></app-nav-header>
<div class="wrapper">
    <div id="psirtPage">
        <div class="main">
            <!-- Banner -->
            <div class="bannerArea">
                <div class="bannerBox">
                    <div class="wordBox" [ngClass]="{ 'wrap-text': isEnglish() }">
                        <h1
                            [style.white-space]="
                                isSmallScreen && isEnglish() ? 'pre-line' : 'normal'
                            ">
                            {{ getTitleKey() | translate }}
                        </h1>
                    </div>
                </div>
            </div>
            <!-- 內文 -->
            <div class="psirtArea" [ngClass]="{ 'psirtArea-english': isEnglish() }">
                <div class="psirtBox">
                    <div class="wordBox">
                        <h2>{{ 'psirt.heading.psirt' | translate }}</h2>
                        <p>
                            {{ 'psirt.content.psirt' | translate }}
                        </p>

                        <h2>{{ 'psirt.heading.contact' | translate }}</h2>
                        <p>
                            {{ 'psirt.content.contact' | translate
                            }}<ng-container *ngIf="isEnglish()">&nbsp;</ng-container
                            ><a
                                href="mailto:psirt@kunyoutech.com.tw"
                                class="email-link"
                                >{{ 'psirt.content.contactEmail' | translate }}</a
                            >
                        </p>

                        <h2>{{ 'psirt.heading.scope' | translate }}</h2>
                        <p>
                            {{ 'psirt.content.scope' | translate
                            }}<ng-container *ngIf="isEnglish()">&nbsp;</ng-container
                            ><a [routerLink]="['/contactUs']" class="email-link">{{
                                'psirt.content.scopeLink' | translate
                            }}</a
                            ><ng-container *ngIf="isEnglish()">.</ng-container
                            ><ng-container *ngIf="!isEnglish()">。</ng-container>
                        </p>

                        <h2>{{ 'psirt.heading.info' | translate }}</h2>
                        <p class="mb-0">
                            {{ 'psirt.content.infoIntro' | translate }}
                        </p>
                        <div class="process-section">
                            <div class="process-item">
                                <div class="icon-box">
                                    <img
                                        src="../../../../assets/images/psirt/info-detail.png"
                                        alt="問題的詳細描述" />
                                </div>
                                <h3>{{ 'psirt.infoItems.detail' | translate }}</h3>
                            </div>
                            <div class="process-item">
                                <div class="icon-box">
                                    <img
                                        src="../../../../assets/images/psirt/info-step.png"
                                        alt="重現漏洞的步驟" />
                                </div>
                                <h3>{{ 'psirt.infoItems.steps' | translate }}</h3>
                            </div>
                            <div class="process-item">
                                <div class="icon-box">
                                    <img
                                        src="../../../../assets/images/psirt/info-products.png"
                                        alt="受影響的產品名稱與具體版本" />
                                </div>
                                <h3>{{ 'psirt.infoItems.products' | translate }}</h3>
                            </div>
                            <div class="process-item">
                                <div class="icon-box">
                                    <img
                                        src="../../../../assets/images/psirt/info-related.png"
                                        alt="相關的補充資料" />
                                </div>
                                <h3>{{ 'psirt.infoItems.related' | translate }}</h3>
                            </div>
                        </div>

                        <h2>{{ 'psirt.heading.reply' | translate }}</h2>
                        <p class="mb-0">
                            {{ 'psirt.content.replyIntro' | translate }}
                        </p>
                        <ul>
                            <li>{{ 'psirt.replyItems.acknowledge' | translate }}</li>
                            <li>{{ 'psirt.replyItems.investigate' | translate }}</li>
                            <li>
                                {{ 'psirt.replyItems.collaborate' | translate }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>
